import { render, staticRenderFns } from "./TextAnalysis.vue?vue&type=template&id=c4b987d4&"
import script from "./TextAnalysis.vue?vue&type=script&lang=js&"
export * from "./TextAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports